import axios from '../axios-auth';

export const currencyService = {
    getCurrencyList,
    saveCurrency,
    getCurrencyDetail,
    getCurrencyByStatus,
    getAllCurrency
};

function getCurrencyList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/currencies", { params });
}

function saveCurrency(currency) {
    if (currency.id) {
        //update currency
        return axios.put('/auth/currency', currency);
    }
    else {
        // create new currency
        return axios.post('/auth/currency', currency);
    }
}

function getCurrencyDetail(id) {
    return axios.get('/auth/currency/' + id);
}

function getCurrencyByStatus(status) {
    return axios.get('auth/currency-by-status/' + status);
}

function getAllCurrency() {
    return axios.get('auth/currency/');
}

